'use strict';

import mergeOpts from './merge-opts';
import {trigger} from './events';

/**
 * This utility toggles a class depending on scroll variation, scrolling up or down,
 * “enabled” means the class is added, “disabled” means the class is removed.
 * This mainly allows to hide and show a fixed header on top of the viewport.
 *
 * @param opts:
 *  - delta: Scroll down delta value (in px) that enables hide-on-scroll
 *  - interval: Interval between checking scrolling value
 *  - speed: Scroll up speed (in px / interval ms) that disables hide-on-scroll
 *  - threshold: If scrollY is less than threshold, disables hide-on-scroll
 */
export default function init(opts) {

    opts = mergeOpts({
        class: 'scrolling-down',
        delta: 20,
        interval: 50,
        speed: 40,
        threshold: 120,
    }, opts);

    var root = document.documentElement;

    var suspended = false;

    var lastScrollTop,
        wasHidden = false,
        didScroll = false;

    // wait for layout to render
    // prevent header to immediately disappear if initial scroll is > 0 
    setTimeout(function () {

        lastScrollTop = window.pageYOffset;

        window.addEventListener('scroll', function () {
            didScroll = true;
        }, {passive: true});

        setInterval(function () {
            if (didScroll) {
                onScroll();
                didScroll = false;
            }
        }, opts.interval);

    }, 2500);

    return {
        suspend: function () {
            suspended = true;
        },
        resume: function () {
            lastScrollTop = window.pageYOffset;
            suspended = false;
        }
    };

    function onScroll() {
        var scrollTop = window.pageYOffset;
        if (suspended) {
            lastScrollTop = scrollTop;
            return;
        }

        // positive value means scrolling down, negative means scrolling up
        var scroll = scrollTop - lastScrollTop;
        var moving = 0;

        if (scroll > opts.delta) {
            // scrolling down by opts.delta pixel, considering the move
            moving = scroll;
            lastScrollTop = scrollTop;
        } else if (scroll < 0) {
            // scrolling up, considering the move is speed is sufficient or if we are under threshold
            moving = Math.abs(scroll) > opts.speed || scrollTop < opts.threshold ? scroll : 0;
            lastScrollTop = scrollTop;
        }

        if (moving !== 0) {
            var hidden = moving > 0 && scrollTop > opts.threshold && !root.classList.contains('nav-on');

            // hidden as changed
            if (hidden !== wasHidden) {
                root.classList.toggle(opts.class, hidden);
                wasHidden = hidden;
                trigger.call(document.body, opts.class, hidden);
            }
        }
    }
}
